// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8c96131eb018b87907663f11d9fa159f2e64528c/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};